// extracted by mini-css-extract-plugin
export var blue = "_4e-g";
export var brand = "_4e-c";
export var darkGrey = "_4e-f";
export var disabled = "_4e-5";
export var disabledSubtle = "_4e-6";
export var error = "_4e-7";
export var green = "_4e-h";
export var grey = "_4e-e";
export var icon = "_4e-0";
export var inherit = "_4e-b";
export var lightGrey = "_4e-d";
export var orange = "_4e-j";
export var pink = "_4e-l";
export var primary = "_4e-1";
export var purple = "_4e-m";
export var quaternary = "_4e-4";
export var red = "_4e-k";
export var secondary = "_4e-2";
export var success = "_4e-a";
export var tertiary = "_4e-3";
export var warning = "_4e-8";
export var warningSecondary = "_4e-9";
export var white = "_4e-n";
export var yellow = "_4e-i";